'use strict';

import $ from 'jquery';
import {defaultOptions} from "./tippy-util";
import { menuTippyInstances, closeAllExceptThis } from './menu-objects/shared-objects';
import {getOptionsFromDataset} from "../../util/dom";

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(async ($container) => {

	// Get the tippy containers
	const $menus = $container.find('[data-menu-inline]');

	if ($menus.length) {

		let activeInlineMenuInstance;

		// Import the tippy lib lazily
		const { default: tippy } = await import('tippy.js');

		for (const menu of $menus) {

			const $menu = $(menu);
			const $menuIndex = $menu.find('.menu-inline__index');
			const $menuTriggers = $menu.find('.menu-inline__item > [data-target]');
			const $yBoundary = $menu.closest('[data-menu-inline-y-boundary]');
			const $xBoundary = $menu.closest('[data-menu-inline-x-boundary]');

			for (const menuTrigger of $menuTriggers) {
				const $menuTrigger = $(menuTrigger);
				const $menuTarget = $menu.find(`#${$menuTrigger.data('target')}`);

				let sizeModifiers = [];

				if ($yBoundary.length || $xBoundary.length) {
					sizeModifiers.push(
						{
							name: 'applyDimensions',
							enabled: true,
							phase: 'beforeWrite',
							fn: (data) => {
								data.state.styles.popper.width = (() => {
									if ($xBoundary.length) {
										return ($xBoundary.width() - data.state.elements.reference.offsetWidth) + 'px';
									}

									return 'auto';
								})();
								data.state.styles.popper.height = (() => {
									if ($yBoundary.length) {
										$(data.state.elements.popper).find('.tippy-box').css({'minHeight': '100%'});
										return $yBoundary.height() + 'px';
									}

									return 'auto';
								})();
								data.state.styles.popper.overflowX = 'auto';
								data.state.styles.popper.overflowY = 'auto';
							},
						}
					);
				}

				menuTippyInstances.add(
					tippy($menuIndex[0], {

						// Merge with default config
						...defaultOptions,

						...getOptionsFromDataset($menuIndex[0], 'tippy', true),
						...getOptionsFromDataset($menuTrigger[0], 'tippy', true),

						// appendTo: $appendTo[0],
						content: (reference) => $menuTarget[0],
						placement: 'right-start',
						// trigger: 'click',
						popperOptions: {
							modifiers: [
								...defaultOptions.popperOptions.modifiers,
								{
									name: 'preventOverflow',
									enabled: false,
								},
								...sizeModifiers,
							],
						},
						triggerTarget: $menuTrigger[0],
						// onTrigger: closeAllExceptThis,
						onMount: closeAllExceptThis,
						onShow(instance) {
							activeInlineMenuInstance = instance;
						},
					})
				);
			}
		}

		window.addEventListener('scroll', () => {
			if ( activeInlineMenuInstance && activeInlineMenuInstance.state.isVisible ) {
				activeInlineMenuInstance.hide()
				activeInlineMenuInstance.reference.blur() // remove focus from target (fix for touch)
			}
		}, { passive: true });
	}

});